import { useQuery, UseQueryOptions } from "react-query"
import {
  getUserBandsCount,
  UserBandsCountResponse,
} from "../util/backend_api/user_bands"

export interface FollowerCounts {
  totalCount: number
  notifiersCount: number
}

export function useUserBandsCountFor(
  bandIds: number[] | null | undefined,
  options?: Omit<
    UseQueryOptions<FollowerCounts, Error>,
    "queryKey" | "queryFn"
  >,
) {
  return useQuery<FollowerCounts, Error>(
    ["user_bands_count", bandIds],
    async () => {
      const response = await getUserBandsCount(bandIds!)
      if (response.success === false) {
        throw new Error(response.error || "Failed to fetch follower count")
      }
      return {
        totalCount: response.total_count,
        notifiersCount: response.notifiers_count,
      }
    },
    {
      enabled: !!bandIds && bandIds.length > 0, // Only run query if bandIds exists and has items
      retry: false,
      ...options,
    },
  )
}
